<template>
  <div id="PartnerPage">
    <Partners
      data-aos="fade-up"
      data-aos-easing="ease-out-back"
      data-aos-delay="50"
      data-aos-duration="1000"
      data-aos-anchor-placement="top-bottom"
    ></Partners>
  </div>
</template>
<script>
import Partners from '@/components/Partners.vue';

export default {
  name: 'PartnerPage',
  metaInfo: {
    title: '合作商家 | ',
  },
  components: {
    Partners,
  },
};
</script>
<style lang="scss" scoped>
</style>
